// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'tiemposHeadline', 'tiemposHeadline Fallback'"},"className":"__className_9ffb52","variable":"__variable_9ffb52"};